namespace $.$$ {
	
	$mol_style_define( $giper_balls_offer, {
		
		Content: {
			padding: $mol_gap.text,
			maxWidth: '800px',
			margin: {
				left: 'auto',
				right: 'auto',
			},
		},
		
	} )
	
}
